import { z } from 'zod';

export type AiArtifactType = 'image' | 'report';

export type AiArtifactImage = {
  fileId: string;
  prompt: string;
};

export type AiArtifactReport = {
  fileId: string;
  prompt: string;
  fileName: string;
  rowCount: number;
};

export type AiArtifactData = AiArtifactImage | AiArtifactReport;

export const aiArtifactSchema = z.object({
  id: z.string(),
  type: z.enum(['image', 'report']),
  data: z.object({
    fileId: z.string(),
    prompt: z.string(),
    fileName: z.string().optional(),
    rowCount: z.number().optional(),
  }),
  aiPromptId: z.string(),
});

export type AiArtifactSchema = z.infer<typeof aiArtifactSchema>;
